import React, { useEffect } from "react";
import "./SearchBar.css";

const SearchBar = ({
  categories = [],
  activeCategory,
  onChangeCategory,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
  isSearchMode,
  onReset,
}) => {
  useEffect(() => {
    const icons = document.querySelectorAll(".category-pill img");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    icons.forEach((icon) => observer.observe(icon));
  }, []);

  return (
    <section className="podcast-search-wrapper">
      <div className="category-search-bar-row">
        {/* Category Pills */}
        <div className="category-scroll-container">
          {categories.map((cat) => (
            <button
              key={cat.name}
              className={`category-pill ${activeCategory === cat.name ? "active" : ""}`}
              onClick={() => onChangeCategory(cat.name)}
            >
              <img src={cat.icon} alt={`${cat.name} icon`} />
              <span>{cat.name}</span>
            </button>
          ))}
        </div>

        {/* Search Input + Buttons */}
        <div className="search-bar-container">
          <input
            type="text"
            placeholder="Search experts by keyword..."
            className="category-search-input"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearchSubmit?.(e.currentTarget.value);
              }
            }}
          />
          <button
            className="search-button"
            onClick={() => onSearchSubmit?.(searchTerm)}
          >
            Search
          </button>
          {isSearchMode && (
            <button className="reset-search" onClick={onReset}>
              Reset
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default SearchBar;
